export default [
    {
        path: '/admin/hr/payroll-cycle-dates',
        name: 'payroll-cycle-date',
        meta: { requiresAuth: true },
        component: () => import('@/pages/human-resource/payroll-cycle-date/index.vue')
    }
]
